import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="page">
      <section className="container" style={{ paddingTop: "var(--s-9)", textAlign: "center" }}>
        <div className="t-eyebrow" style={{ marginBottom: 12 }}>404</div>
        <h1 className="t-display" style={{ fontSize: "var(--t-3xl)", margin: 0 }}>
          That page is <span className="italic">unpublished</span>.
        </h1>
        <p
          className="t-display"
          style={{ fontSize: "var(--t-md)", color: "var(--text-muted)", marginTop: 12 }}
        >
          The route you tried doesn't match anything we issue.
        </p>
        <div style={{ marginTop: 32 }}>
          <Link to="/" className="btn btn-solid">Back to archive</Link>
        </div>
      </section>
    </div>
  );
}
